export const getCommandBarItems = (
  translator,
  onChangeCityAreaIsActive,
  selectedCityAreaIsActive,
  selectedCityAreaId,
  onDeleteCityArea,
  isUpdatingCityArea,
  selectedCityAreaNumberOfHearings,
  openPanel,
) => {
  return [
    {
      key: 'addCityArea',
      name: translator('pages.adminCityAreas.addCityArea'),
      iconProps: {
        iconName: 'Add',
      },
      onClick: openPanel,
      disabled: false,
      buttonStyles,
    },
    {
      key: 'activateCityArea',
      name: translator('pages.adminCityAreas.activateCityArea'),
      iconProps: {
        iconName: 'ActivateOrders',
      },
      onClick: () => onChangeCityAreaIsActive(true),
      disabled:
        isUpdatingCityArea ||
        selectedCityAreaIsActive === null ||
        selectedCityAreaIsActive,
      buttonStyles,
    },
    {
      key: 'deactivateCityArea',
      name: translator('pages.adminCityAreas.inactivateCityArea'),
      iconProps: {
        iconName: 'DeactivateOrders',
      },
      onClick: () => onChangeCityAreaIsActive(false),
      disabled: isUpdatingCityArea || !selectedCityAreaIsActive,
      buttonStyles,
    },
    {
      key: 'deleteCityArea',
      name: translator('pages.adminCityAreas.deleteCityArea'),
      iconProps: {
        iconName: 'Delete',
      },
      onClick: onDeleteCityArea,
      disabled:
        isUpdatingCityArea ||
        selectedCityAreaId === null ||
        selectedCityAreaNumberOfHearings !== 0,
      buttonStyles,
    },
  ];
};

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
